import _mapValues from 'lodash/mapValues';
import { css } from 'styled-components';
import bowser from 'bowser';
import { screenSizes as theme } from './theme';

const sizes = {
  extraLarge: { min: theme.screenXl },
  large: { max: theme.screenLgMax, min: theme.screenLg },
  medium: { max: theme.screenMdMax, min: theme.screenMd },
  small: { max: theme.screenSmMax, min: theme.screenSm },
  extraSmall: { max: theme.screenXsMax, min: theme.screenXs },
  extraExtraSmall: { max: theme.screenXXsMax, min: theme.screenXXs },
  mediumAndAbove: { min: theme.screenMd },
  mediumAndBelow: { max: theme.screenMdMax },
  smallAndBelow: { max: theme.screenSmMax },
  smallAndAbove: { min: theme.screenSmMax },
  smallAndExtraSmall: { min: theme.screenXs, max: theme.screenSmMax },
  smallAndMedium: { min: theme.screenSm, max: theme.screenMdMax },
  mediumAndLarge: { min: theme.screenMd, max: theme.screenLgMax },
  largeAndAbove: { min: theme.screenLg },
  extraSmallAndBelow: { max: theme.screenXXs - 1 },
};

const mediaForSizes = settings => {
  if (settings.min && settings.max) {
    return `@media (min-width: ${settings.min}px) and (max-width: ${settings.max}px)`;
  }
  if (settings.min) {
    return `@media (min-width: ${settings.min}px)`;
  }
  return `@media (max-width: ${settings.max}px)`;
};

const sizeQueries = _mapValues(sizes, settings => {
  return (...args) => css`
    ${mediaForSizes(settings)} {
      ${css(...args)};
    }
  `;
});

const isInternetExplorer = navigator.userAgent.indexOf('MSIE') !== -1
  || navigator.appVersion.indexOf('Trident/') > -1
  || navigator.userAgent.indexOf('Edge') > -1;

const browser = bowser.getParser(window.navigator.userAgent);
export default {
  ...sizeQueries,
  isInternetExplorer,
  IE9: browser.satisfies({ ie: '9' }),
  IE10: browser.satisfies({ ie: '10' }),
  IE11: browser.satisfies({ ie: '11' }),
  safari: browser.is('safari'),
  iOS12: browser.getOSName() === 'iOS' && browser.getOSVersion().length >= 2 && browser.getOSVersion().substr(0, 2) === '12',
  mobile: browser.is('mobile'),
  tablet: browser.is('tablet'),
};
